import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect, useLocation } from 'react-router-dom';
import { defaultAuthorizedRoute } from '~/constants';
import { useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
/**
 * Prevents access to the page if the user is a partially onboarded vendor (does not have a business).
 */ export function withBlockPartiallyOnboardedVendor(Component) {
    return function WithBlockPartiallyOnboardedVendor(props) {
        const location = useLocation();
        const businessId = useStore(selectors.user.businessId);
        const userId = useStore(selectors.user.id);
        const isPartiallyOnboardedVendor = !!userId && !businessId;
        const defaultRouteForVendor = defaultAuthorizedRoute(true);
        return isPartiallyOnboardedVendor ? location.pathname === defaultRouteForVendor ? /*#__PURE__*/ _jsx("div", {
            "data-testid": "blocked-partially-onboarded-vendor"
        }) : /*#__PURE__*/ _jsx(Redirect, {
            to: {
                pathname: defaultRouteForVendor,
                search: location.search
            }
        }) : /*#__PURE__*/ _jsx(Component, _object_spread({}, props));
    };
}
